module.exports = __webpack_public_path__ + "img/full3-min.bc04250d.png";